import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=ad480078&scoped=true&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=ad480078&lang=scss&scoped=true&"
import style1 from "./TransactionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad480078",
  null
  
)

export default component.exports